(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ft-collection-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function updateHeaderClearance(root) {
      var header = document.querySelector('.header');
      var position = header ? window.getComputedStyle(header).position : '';
      var offset = position === 'fixed' || position === 'absolute' ? Math.max(0, Math.ceil(header.getBoundingClientRect().bottom)) : 0;
      root.querySelectorAll('[data-ft-collection-hero]').forEach(function (hero) {
        hero.style.setProperty('--ft-collection-header-offset', offset + 'px');
      });
    }
    function updateAll() { updateHeaderClearance(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll);
    else updateAll();
    window.addEventListener('load', updateAll);
    window.addEventListener('resize', updateAll);
    document.addEventListener('shopify:section:load', function (event) { updateHeaderClearance(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-collection-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function slidesIn(grid) { return Array.from(grid.querySelectorAll('[data-ft-collection-slide]')); }
    function perPage() { return window.matchMedia('(max-width: 767px)').matches ? 2 : 4; }

    function syncControls(grid) {
      var controls = grid.parentElement.querySelector('[data-ft-collection-controls]');
      if (!controls) return;
      var slides = slidesIn(grid);
      var pages = Math.ceil(slides.length / perPage());
      controls.hidden = pages < 2 || grid.scrollWidth <= grid.clientWidth + 1;
      if (controls.hidden) return;
      var dots = controls.querySelector('[data-ft-collection-dots]');
      if (dots.children.length !== pages) {
        dots.replaceChildren();
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Show products ' + (i * perPage() + 1) + ' to ' + Math.min((i + 1) * perPage(), slides.length));
          dot.dataset.page = i;
          dots.appendChild(dot);
        }
      }
      var maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
      var page = maxScroll ? Math.round(grid.scrollLeft / maxScroll * (pages - 1)) : 0;
      controls.querySelector('[data-ft-collection-prev]').disabled = page === 0;
      controls.querySelector('[data-ft-collection-next]').disabled = page === pages - 1;
      Array.from(dots.children).forEach(function (dot, index) {
        if (index === page) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function scrollToPage(grid, page) {
      var slides = slidesIn(grid);
      var index = Math.min(page * perPage(), slides.length - 1);
      if (index < 0) return;
      grid.scrollTo({
        left: slides[index].offsetLeft - slides[0].offsetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    function initSection(section) {
      if (section.dataset.ftCollectionInitialized) return;
      section.dataset.ftCollectionInitialized = 'true';
      var nativeSort = section.querySelector('[data-ft-collection-sort-native]');
      if (nativeSort) nativeSort.addEventListener('change', function () { nativeSort.form.submit(); });
      var grids = Array.from(section.querySelectorAll('[data-ft-collection-slider]'));
      grids.forEach(function (grid) {
        if (!slidesIn(grid).length) return;
        grid.dataset.ftCollectionReady = 'true';
        var controls = grid.parentElement.querySelector('[data-ft-collection-controls]');
        if (!controls) return;
        controls.addEventListener('click', function (event) {
          var button = event.target.closest('button');
          if (!button || !controls.contains(button)) return;
          var pages = Math.ceil(slidesIn(grid).length / perPage());
          var current = Array.from(controls.querySelector('[data-ft-collection-dots]').children).findIndex(function (dot) {
            return dot.getAttribute('aria-current') === 'true';
          });
          if (button.hasAttribute('data-ft-collection-prev')) scrollToPage(grid, Math.max(0, current - 1));
          else if (button.hasAttribute('data-ft-collection-next')) scrollToPage(grid, Math.min(pages - 1, current + 1));
          else if (button.dataset.page !== undefined) scrollToPage(grid, Number(button.dataset.page));
        });
        var scrollScheduled = false;
        grid.addEventListener('scroll', function () {
          if (scrollScheduled) return;
          scrollScheduled = true;
          window.requestAnimationFrame(function () { scrollScheduled = false; syncControls(grid); });
        }, { passive: true });
        syncControls(grid);
      });
      var groupSort = section.querySelector('[data-ft-collection-sort-groups]');
      if (groupSort) groupSort.addEventListener('change', function () {
        grids.forEach(function (grid) {
          var slides = slidesIn(grid);
          slides.sort(function (a, b) {
            if (groupSort.value === 'price-asc' || groupSort.value === 'price-desc') {
              var aPrice = a.hasAttribute('data-price') ? Number(a.dataset.price) : Infinity;
              var bPrice = b.hasAttribute('data-price') ? Number(b.dataset.price) : Infinity;
              if (aPrice === Infinity) return bPrice === Infinity ? 0 : 1;
              if (bPrice === Infinity) return -1;
              return groupSort.value === 'price-asc' ? aPrice - bPrice : bPrice - aPrice;
            }
            if (groupSort.value === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title, 'en-US');
            if (groupSort.value === 'title-desc') return b.dataset.title.localeCompare(a.dataset.title, 'en-US');
            return Number(a.dataset.index) - Number(b.dataset.index);
          });
          slides.forEach(function (slide) { grid.appendChild(slide); });
          grid.scrollLeft = 0;
          syncControls(grid);
        });
      });
      var onResize = function () {
        grids.forEach(function (grid) { grid.scrollLeft = 0; syncControls(grid); });
      };
      window.addEventListener('resize', onResize);
      section.ftCollectionCleanup = function () { window.removeEventListener('resize', onResize); };
    }

    function initAll(root) {
      if (root.matches && root.matches('[data-ft-collection-products]')) initSection(root);
      root.querySelectorAll('[data-ft-collection-products]').forEach(initSection);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    else initAll(document);
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      var section = event.target.matches('[data-ft-collection-products]') ? event.target : event.target.querySelector('[data-ft-collection-products]');
      if (section && section.ftCollectionCleanup) section.ftCollectionCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mobile = window.matchMedia('(max-width: 767px)');
    var prev = '<button type="button" class="ft-featured-collection__arrow ft-featured-collection__arrow--prev" aria-label="Previous products"><svg viewBox="0 0 24 24" fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg></button>';
    var next = '<button type="button" class="ft-featured-collection__arrow ft-featured-collection__arrow--next" aria-label="Next products"><svg viewBox="0 0 24 24" fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg></button>';

    function sections(root) {
      if (root.matches && root.matches('.ft-featured-collection')) return [root];
      return Array.prototype.slice.call(root.querySelectorAll('.ft-featured-collection'));
    }
    function destroy(section) {
      var grid = section.querySelector('[data-ft-featured-collection-grid]');
      if (grid && window.jQuery && window.jQuery.fn.slick && grid.classList.contains('slick-initialized')) {
        window.jQuery(grid).slick('unslick');
      }
    }
    function init(section) {
      var grid = section.querySelector('[data-ft-featured-collection-grid]');
      if (!grid || !window.jQuery || !window.jQuery.fn.slick) return;
      destroy(section);
      var perView = mobile.matches ? 2 : 4;
      if (grid.querySelectorAll('.ft-featured-collection__slide').length <= perView) return;
      window.jQuery(grid).slick({ slidesToShow: perView, slidesToScroll: perView, infinite: false, arrows: true, dots: true, prevArrow: prev, nextArrow: next });
    }
    function initAll(root) { sections(root).forEach(init); }
    function reinitAll() { initAll(document); }
    if (mobile.addEventListener) mobile.addEventListener('change', reinitAll);
    else mobile.addListener(reinitAll);
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { sections(event.target).forEach(destroy); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reinitAll);
    else reinitAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-product-showcase"] && !Shopify.designMode) return;
  try {
    
  var ftShowcaseMobile = window.matchMedia('(max-width: 767px)');
  var ftShowcasePrev = '<button type="button" class="ft-product-showcase__arrow ft-product-showcase__arrow--prev" aria-label="Previous products"><svg viewBox="0 0 24 24" fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg></button>';
  var ftShowcaseNext = '<button type="button" class="ft-product-showcase__arrow ft-product-showcase__arrow--next" aria-label="Next products"><svg viewBox="0 0 24 24" fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg></button>';

  function ftShowcaseSections(root) {
    if (root.matches && root.matches('.ft-product-showcase')) return [root];
    return Array.prototype.slice.call(root.querySelectorAll('.ft-product-showcase'));
  }

  function ftShowcaseDestroy(section) {
    var grid = section.querySelector('[data-ft-product-showcase-grid]');
    if (grid && window.jQuery && window.jQuery.fn.slick && grid.classList.contains('slick-initialized')) {
      window.jQuery(grid).slick('unslick');
    }
  }

  function ftShowcaseInit(section) {
    var grid = section.querySelector('[data-ft-product-showcase-grid]');
    if (!grid || !window.jQuery || !window.jQuery.fn.slick) return;

    ftShowcaseDestroy(section);
    if (section.classList.contains('ft-product-showcase--grid')) return;
    var perView = ftShowcaseMobile.matches ? 2 : 4;
    var count = grid.querySelectorAll('.ft-product-showcase__slide:not(.ft-product-showcase__slide--empty)').length;
    if (count <= perView) return;

    window.jQuery(grid).slick({
      slidesToShow: perView,
      slidesToScroll: perView,
      infinite: false,
      arrows: true,
      dots: true,
      prevArrow: ftShowcasePrev,
      nextArrow: ftShowcaseNext
    });
  }

  function ftShowcaseInitAll(root) {
    ftShowcaseSections(root).forEach(ftShowcaseInit);
  }

  function ftShowcaseReinitAll() {
    ftShowcaseInitAll(document);
  }

  if (ftShowcaseMobile.addEventListener) {
    ftShowcaseMobile.addEventListener('change', ftShowcaseReinitAll);
  } else {
    ftShowcaseMobile.addListener(ftShowcaseReinitAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    ftShowcaseInitAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    ftShowcaseSections(event.target).forEach(ftShowcaseDestroy);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('.ft-product-showcase__slide');
    if (!slide) return;
    var grid = slide.closest('[data-ft-product-showcase-grid]');
    if (grid && grid.classList.contains('slick-initialized')) {
      window.jQuery(grid).slick('slickGoTo', Number(slide.getAttribute('data-slick-index')));
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ftShowcaseReinitAll);
  } else {
    ftShowcaseReinitAll();
  }

  } catch(e) { console.error(e); }
})();
})();
